import WbIncandescentOutlinedIcon from "@mui/icons-material/WbIncandescentOutlined";
import { Autocomplete, CircularProgress, InputAdornment, TextField } from "@mui/material";
import { useModalOfferContext } from "../../context";
import { useModalOfferAppellations } from "../../logics/appellation";

interface IAppellationInputProps {
  className: string;
}

export const AppellationInput = ({ className }: IAppellationInputProps) => {
  const { offer, appellation, errors, disabled } = useModalOfferContext();
  const { appellationsOptions, handleChange, handleInputChange, handleOfferName, loadingGetJob } =
    useModalOfferAppellations();
  return (
    <>
      <TextField
        id="offer-job-input"
        label="Poste occupé*"
        size="small"
        value={offer.name ?? ""}
        error={!!errors.name}
        onChange={(event) => {
          handleOfferName(event);
        }}
        sx={{
          "&::first-letter": { textTransform: "capitalize" },
        }}
        disabled={disabled}
      />
      <Autocomplete
        id="offer-appellation-job"
        size="small"
        options={appellationsOptions}
        disabled={!offer?.name || disabled}
        value={appellation}
        onChange={handleChange}
        onInputChange={(event, value) => {
          handleInputChange(event, value);
        }}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        getOptionLabel={(option) => (typeof option !== "string" && option.libelle) || ""}
        renderInput={(params) => {
          params.InputProps.startAdornment = (
            <>
              <InputAdornment position="start">
                <WbIncandescentOutlinedIcon color="error" />
              </InputAdornment>
              {params.InputProps.startAdornment}
            </>
          );
          params.InputProps.endAdornment = (
            <>
              {loadingGetJob ? (
                <InputAdornment position="end">
                  <CircularProgress color="inherit" size={20} />
                </InputAdornment>
              ) : null}
              {params.InputProps.endAdornment}
            </>
          );
          return <TextField {...params} label="Appellation détectée*" fullWidth error={!!errors.appellation} />;
        }}
      />
    </>
  );
};
